import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EfImgVideo from '../ef-img-video';
import EfLink from '../ef-link';
import IconAdd from './IconAdd';
import IconClose from './IconClose';
import gtm from '@/utils/gtm';
import './index.scss';

export interface EfTabSectionItemProps {
    /**
     * tab名称
     */
    tabName: string;

    /**
     * 底部内容
     */
    bottomContent?: React.ReactNode;
    /**
     * 底部按钮-是否有
     */
    hadFooterBtn?: boolean;
    /**
     * 底部按钮-文案
     */
    footerBtnText?: string;
    /**
     * 底部按钮-弹窗内容
     */
    footerBtnWinContent?: React.ReactNode;
    /**
     * 资源链接是否是视频
     */
    isVideo?: boolean;
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;
    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;
    /**
     * 更多文案
     */
    moreText?: string;
    /**
     * 更多链接
     */
    moreHref?: string;
    /**
     * 是否直接展示更多链接按钮
     */
    showMoreBtn?: boolean;
    /**
     * 图片上固定位置的 text or icon
     */
    fixedElement?: any;
}
interface EfTabSectionProps {
    /**
     * 轮播间隔
     */
    spaceBetween?: number;
    /**
     * 是否循环
     */
    loop?: boolean;
    /**
     * 显示方式
     */
    type?: 'LROpacity';
    /**
     * 主题色
     */
    theme?: 'white' | 'black';
    /**
     * 样式名
     */
    className?: string;
    /**
     * 点击更多
     */
    moreCallback?: (item1: EfTabSectionItemProps) => void;
    /**
     * 列表
     */
    list: EfTabSectionItemProps[];
    /**
     * 埋点事件
     */
    gtm_list_name?: string;
    /**
     *  底部按钮-点击回调
     */
    footerBtnCallback?: (item1: EfTabSectionItemProps) => void;
}

/**
 * 维护:谢保林
 *
 * tab 切换列表
 */
//const EfTabSection: React.FC<EfTabSectionProps> = ({ spaceBetween = 20, theme = 'white', className, list, moreCallback }) => {
const EfTabSection: React.FC<EfTabSectionProps> = ({
    spaceBetween = 20,
    loop = true,
    type,
    theme = 'white',
    className,
    list,
    moreCallback,
    footerBtnCallback,
    gtm_list_name,
}) => {
    const prefixCls = `ef-tab-section`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-${theme}`]: theme,
        [`${prefixCls}-${type}`]: type,
    });
    const refDialog = useRef(null); //弹窗
    const [activeIndex, setActiveIndex] = useState(0); //选中下标
    const [activeItem, setActiveItem] = useState(list[0] || {}); //选中元素
    const [dialogShow, setDialogShow] = useState(false); //打开弹窗
    const [swiperA, setSwiperA] = useState<any>(null); // 用于点击tab时执行轮播切换
    const tabsContainerRef: any = useRef<HTMLDivElement>();

    // gtm 埋点
    const gtmEvent = (activeItem2?: any) => {
        const activeItem3 = activeItem2 || activeItem;
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: gtm_list_name || 'none',
            button_name: activeItem3.tabName,
        });
    };
    // 切换tab执行的动作
    const toggleItemCallback = (item: EfTabSectionItemProps, index: number) => {
        setActiveIndex(index);
        setActiveItem(item);
        gtmEvent(item);
    };
    // 点击切换tab
    const toggleItemHandle = (item: EfTabSectionItemProps, index: number) => {
        swiperA.slideToLoop(index);
        setTimeout(() => {
            tabsContainerRef.current.scrollTo({
                left: 100 * index,
                behavior: 'smooth',
            });
        }, 200);
        // swiperA.slideTo(loop && index === 0 ? list?.length : index);
    };
    // 点击打开弹窗
    const openDialogHandle = () => {
        (refDialog.current as any).showModal();
        setDialogShow(true);

        footerBtnCallback && footerBtnCallback(activeItem);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_details',
                tab: activeItem.tabName,
                button_name: activeItem.footerBtnText,
            });
        } catch (error) {}
    };
    // 点击关闭弹窗
    const closeDialogHandle = () => {
        (refDialog.current as any).close();
        setDialogShow(false);
    };

    // 点击更多
    const moreBtnHandle = (item: EfTabSectionItemProps) => {
        moreCallback && moreCallback(item);
        gtm.push({
            event: 'uaEvent',
            event_name: 'view_more',

            list_name: gtm_list_name || 'none',
            button_name: activeItem.moreText,
        });
    };

    // 轮播组件内的切换
    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        toggleItemCallback(list[index], index);
    };
    return (
        <div className={classes}>
            <div className={`${prefixCls}-c1`}>
                <Swiper
                    className={`${prefixCls}-c1-swiper`}
                    modules={[Navigation]}
                    navigation={true}
                    pagination={true}
                    loop={loop}
                    spaceBetween={spaceBetween}
                    centeredSlides={true}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    onSlideChange={handleSlideChange}
                    onSwiper={(swiperIns: any) => setSwiperA(swiperIns)}
                >
                    {list?.map((item: any, k: number) => (
                        <SwiperSlide className={`${prefixCls}-c1-item`} key={k}>
                            <EfImgVideo
                                isVideo={item.isVideo}
                                pc={item.pc}
                                pad={item.pad}
                                h5={item.h5}
                                poster={item?.poster}
                                posterH5={item?.posterH5 || item?.poster}
                                autoPlay={true}
                                loop={true}
                            />
                            {!!item?.fixedElement && <div className={`${prefixCls}-c1-item-fixed-element`}>{item.fixedElement}</div>}
                            {(item.moreHref || item.showMoreBtn) && item.moreText && (
                                <EfLink
                                    href={item.moreHref}
                                    className={`${prefixCls}-c1-item-href`}
                                    onClick={() => {
                                        moreBtnHandle(item);
                                    }}
                                >
                                    {item.moreText}
                                </EfLink>
                            )}
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className={`${prefixCls}-h`}>
                <div className={`${prefixCls}-h-in`} ref={tabsContainerRef}>
                    {list?.map((item: EfTabSectionItemProps, index: number) => {
                        return (
                            <div
                                key={index}
                                className={`${prefixCls}-h-item${activeIndex === index ? ` ${prefixCls}-h-item-active` : ''}`}
                                onClick={() => {
                                    toggleItemHandle(item, index);
                                }}
                            >
                                {item.tabName}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className={`${prefixCls}-c2${dialogShow ? ` ${prefixCls}-c2-active` : ''}`}>
                {activeItem?.bottomContent && <div className={`${prefixCls}-c2-content`}>{activeItem?.bottomContent}</div>}
                {activeItem?.hadFooterBtn && (
                    <>
                        <button className={`${prefixCls}-c2-btn`} onClick={openDialogHandle}>
                            {activeItem.footerBtnText}
                            <span className={`${prefixCls}-c2-btn-icon`}>
                                <IconAdd />
                            </span>
                        </button>
                        <dialog className={`${prefixCls}-c2-dialog`} ref={refDialog}>
                            <div className={`${prefixCls}-c2-dialog-in`}>
                                <div className={`${prefixCls}-c2-dialog-body`}>
                                    {activeItem.footerBtnWinContent}
                                    <div className={`${prefixCls}-c2-dialog-close`} onClick={closeDialogHandle}>
                                        <IconClose />
                                    </div>
                                </div>
                            </div>
                        </dialog>
                    </>
                )}
            </div>
        </div>
    );
};

export default EfTabSection;
